module.exports = __webpack_public_path__ + "img/图1-3留装订边的图框格式.fba669a3.png";